import React from 'react'
import { Container, Modal } from 'react-bootstrap'
import {
  ModalContainer,
  Header,
  ModalTitle,
  ModalSubtitle,
  ModalFooter,
  CancelButton,
  OkButton,
} from './style.js'

const ConfirmDialog = (props) => {
  const {
    show,
    onConfirm,
    onCancel = () => null,
    title = 'Are you sure?',
    subtitle,
    body,
    confirmText = 'YES',
    cancelText = 'NO',
    ...rest
  } = props

  return (
    <ModalContainer show={show} onHide={onCancel} {...rest}>
      <Header closeButton>
        <Modal.Title>
          <ModalTitle>{title}</ModalTitle>
          {subtitle && <ModalSubtitle>{subtitle}</ModalSubtitle>}
        </Modal.Title>
      </Header>
      {body && (
        <Modal.Body className="p-0">
          <Container>{body}</Container>
        </Modal.Body>
      )}
      <ModalFooter>
        <OkButton primary="true" variant="primary" onClick={onConfirm}>
          <span>{confirmText}</span>
        </OkButton>

        <CancelButton onClick={onCancel} variant="secondary">
          <span>{cancelText}</span>
        </CancelButton>
      </ModalFooter>
    </ModalContainer>
  )
}

export default ConfirmDialog
